import { useState } from "react";
import { updateUserAddress } from "../../../services/addressApi/addressApi";

export default function AddressEditForm({ data, addressTypes, onSuccess, onCancel }) {

  const [form, setForm] = useState({
    AddressTitle: data.addressTitle,
    FaltHousNumber: data.faltHousNumber,
    Street: data.street,
    Locality: data.locality,
    Pincode: data.pincode,
    AddressTypeID: data.addressTypeID,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...data, ...form };
    const response = await updateUserAddress(payload);
    alert(response.message);
    onSuccess();
  };

  const fields = [
    { label: "Address Title",      key: "AddressTitle",    icon: "🏷️" },
    { label: "Flat / House Number", key: "FaltHousNumber", icon: "🏠" },
    { label: "Street",             key: "Street",          icon: "🛣️" },
    { label: "Locality",           key: "Locality",        icon: "📍" },
    { label: "Pincode",            key: "Pincode",         icon: "📮" },
  ];

  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">

      {/* ── HEADER ── */}
      <div
        className="flex items-center gap-3 px-6 py-4 border-b border-gray-100"
        style={{ backgroundColor: "#fff5f5" }}
      >
        <div
          className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: "#fee2e2" }}
        >
          <span style={{ fontSize: 18 }}>✏️</span>
        </div>
        <div>
          <h2 className="m-0 text-base font-semibold" style={{ color: "#111827" }}>
            Update Address
          </h2>
          <p className="m-0 text-xs" style={{ color: "#9ca3af" }}>
            Edit your saved address details
          </p>
        </div>
      </div>

      {/* ── FORM ── */}
      <form onSubmit={handleSubmit} style={{ padding: "20px" }}>

        {/* INPUT FIELDS */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 16 }}>
          {fields.map((f) => (
            <div key={f.key}>
              <label
                style={{
                  display: "block",
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#6b7280",
                  marginBottom: 5,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                }}
              >
                {f.icon} {f.label}
              </label>
              <input
                placeholder={f.label}
                value={form[f.key]}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                required
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  fontSize: 14,
                  color: "#111827",
                  backgroundColor: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 10,
                  outline: "none",
                  boxSizing: "border-box",
                  transition: "border-color 0.15s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#dc2626")}
                onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
              />
            </div>
          ))}

          {/* SELECT */}
          <div>
            <label
              style={{
                display: "block",
                fontSize: 12,
                fontWeight: 600,
                color: "#6b7280",
                marginBottom: 5,
                textTransform: "uppercase",
                letterSpacing: "0.4px",
              }}
            >
              🏷️ Address Type
            </label>
            <select
              value={form.AddressTypeID}
              onChange={(e) => setForm({ ...form, AddressTypeID: e.target.value })}
              style={{
                width: "100%",
                padding: "10px 14px",
                fontSize: 14,
                color: "#111827",
                backgroundColor: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 10,
                outline: "none",
                boxSizing: "border-box",
                cursor: "pointer",
                transition: "border-color 0.15s",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#dc2626")}
              onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
            >
              {addressTypes.map((t) => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>
          </div>
        </div>

        {/* ── BUTTONS ── */}
        <div
          className="flex gap-3"
          style={{ paddingTop: 16, borderTop: "1px solid #f3f4f6" }}
        >
          {/* UPDATE */}
          <button
            type="submit"
            className="flex-1"
            style={{
              backgroundColor: "#dc2626",
              color: "#ffffff",
              fontSize: 14,
              fontWeight: 600,
              padding: "11px 24px",
              border: "none",
              borderRadius: 10,
              cursor: "pointer",
              transition: "background-color 0.15s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#b91c1c")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#dc2626")}
          >
            <span style={{ color: "#ffffff" }}>Update Address</span>
          </button>

          {/* CANCEL */}
          <button
            type="button"
            onClick={onCancel}
            className="flex-1"
            style={{
              backgroundColor: "#ffffff",
              color: "#374151",
              fontSize: 14,
              fontWeight: 600,
              padding: "11px 24px",
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              cursor: "pointer",
              transition: "background-color 0.15s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffffff")}
          >
            <span style={{ color: "#374151" }}>Cancel</span>
          </button>
        </div>

      </form>
    </div>
  );
}